import { COLORS } from 'helpers/globals'

export const third = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '33%',
  marginTop: '1rem',
  color: COLORS.primary,
  verticalAlign: 'top',
  '& .list:last-child': {
    color: 'black'
  }
}

const row = {
  display: 'flex',
  alignItems: 'center',
  marginLeft: '5rem',
  fontSize: '1.6rem'
}

export const list = {
  fontSize: '1.5rem',
  'borderRight': `1px solid ${COLORS.quaternary}`,
  'borderBottom': `1px solid ${COLORS.quaternary}`,
  height: '100%',
  overflowY: 'auto'
}

export const listItem = {
  cursor: 'pointer',
  padding: '0 1.5rem 0 .7rem',
  lineHeight: '2.7rem',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  '&:hover': { color: COLORS.secondary },
  '&:nth-child(even)': {
    background: COLORS.tertiary
  }
}

export const selected = {
  ...listItem,
  color: 'black',
  cursor: 'default',
  background: 'rgba(66, 139, 202, 0.6) !important',
  '&:hover': { color: 'black' }
}

export default {
  modelSelector: {
    height: 'calc(80vh - 70px)',
    display: 'flex',
    flexDirection: 'column'
  },
  columnWrapper: {
    flex: '1 1 auto',
    minHeight: 0,
    display: 'flex'
  },
  topElements: {
    display: 'flex',
    alignItems: 'center'
  },
  searchWrapper: {
    flex: '1 0 auto',
    '& .search': {
      padding: '.5rem 1rem',
      outline: 'none',
      width: '100%'
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '1rem',
    margin: ({ isMobile }) => isMobile ? '1rem' : 0
  },
  firstRow: {
    ...row,
    flexDirection: ({ isMobile }) => isMobile ? 'column' : 'row',
    alignItems: ({ isMobile }) => isMobile ? 'flex-start' : 'center'
  },
  inputWrapper: {
    flex: '0 1 auto',
    marginRight: '3.2rem',
    marginLeft: '.5rem',
    display: 'flex',
    fontSize: '1.2rem',
    fontWeight: 400,
    '&:hover': { cursor: 'pointer' }
  },
  viewChoice: {
    padding: '0.4rem 0.8rem',
    borderTop: '1px solid #2972B1',
    borderBottom: '1px solid #2972B1',
    '&:first-of-type': {
      borderRadius: '.75rem 0 0 .75rem',
      borderLeft: '1px solid #2972B1'
    },
    '&:last-of-type': {
      borderRadius: '0 .75rem .75rem 0',
      borderRight: '1px solid #2972B1'
    },
    '&:not(:last-of-type)': { borderRight: `2px solid ${COLORS.secondary}` },
    color: COLORS.primary,
    background: 'white',
    '&:hover:not(.selected)': {
      color: 'white',
      background: COLORS.primary
    },
    '&.selected': {
      color: 'white',
      background: COLORS.primary,
      '&:hover': { cursor: 'not-allowed' }
    }
  },
  genericButton: {
    '& button': {
      float: 'right',
      fontSize: '1.4rem',
      lineHeight: '1.4rem',
      height: '3rem',
      borderRadius: '.5rem',
      '&[disabled]': { cursor: 'not-allowed' },
      '& svg': {
        marginRight: '.6rem',
        fontSize: '1.5rem'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/style.js